import { createAction, props } from '@ngrx/store';

export const setEvent = createAction('[Event Page] Upsert', props<any>());
